module.exports = __webpack_public_path__ + "static/media/spinner.d9ad4c03.gif";